<template>
  <div>
        
    <el-table
            :data="data_list.slice(($store.getters.getDefaultPageLimit*page_number)-$store.getters.getDefaultPageLimit, 
                ($store.getters.getDefaultPageLimit*page_number))"
            style="width: 100%"
            :default-sort = "{prop: 'appointment_date', order: 'ascending'}">
          
          <el-table-column 
            sortable
            prop="appointment_date"
            label="Promise Date" align="left">
            <template slot-scope="scope">
                <el-popover
                    v-if="$store.state.production.planner.search_type <2"
                    placement="right"
                    width="400"
                    content="Loading..."
                    trigger="click">
                        <br>
                    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;">
                        
                        <span>
                           <b>{{scope.row.sale_number}}-{{scope.row.sl_no}}-{{scope.row.qty_sl_no}}{{scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''}}</b>
                        </span>
                        <div style="margin-top: 20px;">
                            <span type="label">Change Scheduled Date</span>
                            <br>
                            <el-date-picker
                                size="small"
                                type="date"
                                style="width: 350px;"
                                v-model="scope.row.appointment_date"
                                value-format="yyyy-MM-dd"
                                format="MMM dd yyyy">
                            </el-date-picker> 
                        </div>
                        <div style="margin-top: 10px;">
                            <span type="label">Remarks</span>
                            <br>
                            <el-input @focus="$event.target.select()"
                                placeholder="Remarks"
                                size="small"
                                clearable
                                style="width: 350px; text-align: left;"
                                v-model="scope.row.schedule_notes"
                                @keyup.enter.native="updateScheduledDate(scope.row)">
                            </el-input>
                        </div>
                        
                        <el-button @click="updateScheduledDate(scope.row)" size="small" :type="'primary'" style="margin-top: 10px;">
                            Save
                        </el-button>

                    </div>
                    <el-button slot="reference" size="small">
                        {{scope.row.appointment_date_changed}}
                        {{scope.row.appointment_type === 0 ? '(D)' : '(T)'}}
                    </el-button>
                </el-popover>
                <span v-else class="rowFontSize">
                    {{scope.row.appointment_date_changed}} {{scope.row.appointment_type === 1 ? '(T)' : '(D)'}}
                </span>
            </template>
          </el-table-column>
        
            <el-table-column 
            sortable
            prop="customer_name"
            label="Customer Name">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    {{scope.row.customer_name}}
                </span>                
            </template>
          </el-table-column>  
          <el-table-column 
            sortable
            prop="sale_number"
            label="Order#">
            <template slot-scope="scope">
                <!--<span class="rowFontSize" >
                    {{scope.row.work_order_number}}
                </span> -->
                <el-link class="rowFontSize" @click="openWorkOrder(scope.row)">
                    {{scope.row.work_order_number}}
                </el-link>                
            </template>
          </el-table-column>

          <el-table-column 
            sortable
            prop="template_name"
            label="Garment Name">
            <template slot-scope="scope">
                <span class="rowFontSize">
                    {{scope.row.template_name}}
                </span>                
            </template>
          </el-table-column>

          <el-table-column 
            sortable
            prop="work_order_status"
            label="Status">
            <template slot-scope="scope">
                <el-tag 
                    size="small" 
                    :type="(scope.row.process_name == 'Ready For Delivery' || scope.row.process_name == 'Ready For Trial') ? 'success' 
                        : scope.row.work_status === 0 ? 'info' 
                            : scope.row.work_status === 1 ? 'success' 
                                : scope.row.work_status === 2 ? 'warning' 
                                    : scope.row.work_status === 3 ? 'danger' : '' " effect="dark">
                   {{all_list ? scope.row.process_name+' ' : ''}}{{(scope.row.process_name == 'Ready For Delivery' || scope.row.process_name == 'Ready For Trial') ? '' : scope.row.work_order_status}}
                </el-tag>                               
            </template>
          </el-table-column>  
            <el-table-column 
            sortable
            prop="priority_date"
            label="Priority Date" width="165">
            <template slot-scope="scope">
                <el-date-picker
                    @change="togglePriority(scope.row, false)"
                    :disabled="!scope.row.added_to_priority"
                    size="small"
                    type="date"
                    v-model="scope.row.priority_date"
                    style="width: 140px;" 
                    value-format="yyyy-MM-dd"
                    format="MMM dd yyyy">
                </el-date-picker>
            </template>
          </el-table-column>
            <el-table-column
                fixed="right"
                label=""
                width="70">
                <template slot-scope="scope">
                    <div style="text-align: right; display: flex; flex-direction: row; justify-content: flex-end; align-items: flex-end;">
                        
                        <a 
                            @click="togglePriority(scope.row)"
                            v-if="!calendar_view"
                            :title="scope.row.added_to_priority ? 'Remove From Priority' : 'Add To Priority'"
                            style="cursor: pointer; margin-right: 20px;">
                            <i :class="'el-icon-warning'" :style="{color: scope.row.added_to_priority ? 'green' : 'red', fontSize: '16px'}"></i>
                        </a>

                        <a 
                            v-if="!calendar_view"
                            title="Add Task"
                            @click="$emit('addTask', {title: scope.row.customer_name+' ('+scope.row.work_order_number+')', 
                            description: scope.row.process_name+', '+scope.row.work_order_status})" 
                            style="cursor: pointer;">
                            <i :class="'el-icon-date'"></i>
                        </a>

                    </div>                                        
                </template>
            </el-table-column>

        </el-table>
        
        <br>
        <div style="text-align: right;">
          <el-pagination
              background
              @size-change="handleSizeChange"
              :current-page.sync="page_number"
              :page-size.sync="$store.getters.getDefaultPageLimit"
              layout="total, sizes, prev, pager, next"
              :page-sizes="[5, 10, 20, 30, 40, 50, 100]"
              :total="data_list.length">
          </el-pagination>
        </div>

        <el-dialog
            :title="'Work-Order: '+work_order_title"
            v-if="showWorkOrder"
            fullscreen
            :visible.sync="showWorkOrder"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body
            :show-close="false">
            <WorkOrder
                :popup="true"
                :shortcut="true"
                @closed="showWorkOrder = false"/>
        </el-dialog>

  </div>
</template>

<script>
import WorkOrder from '../../../WorkOrder/Index.vue'

export default {
    components: {WorkOrder},
    props: ['data_list', 'searchType', 'store_id', 'calendar_view', 'all_list'],
    data() {
        return {
            work_order_title: '',
            sale_index: 0,
            showWorkOrder: false,
            page_number: 1
        }
    },
    computed: {
        getStoreId() {
            return this.store_id !== null ? this.store_id : 0
        }
    },
    methods: {
        togglePriority(rowData, toggle=true) {
            if(toggle) {
                rowData.added_to_priority = !rowData.added_to_priority
            }
            this.$store.dispatch('updatePriority', {id: rowData.id, priority_date: rowData.priority_date, priority: rowData.added_to_priority})
            
        },
        async handleSizeChange($val) {
            this.$store.state.master.default_page_limit = parseInt($val)
            await this.$store.dispatch('updatePageLimit', {limit: this.$store.state.master.default_page_limit})            
        },
        openWorkOrder(rowData) {
            if(this.checkIfModuleAccessAvailable('/manageworkorders', 'can_edit')) {
                
                this.$store.commit('resetSingleWorkOrderData')
                this.rowData = rowData
                this.$store.dispatch('fetchSingleWorkOrder', {
                    work_order_id: rowData.work_order_id,
                    sale_item_id: rowData.sale_item_id,
                    tailoring_item_id: rowData.tailoring_item_id,
                    customer_id: rowData.customer_id
                })

                this.sale_index = rowData.sl_no
                this.work_order_title = rowData.work_order_number
                this.showWorkOrder = true

            }
            
        },
        updateScheduledDate(rowData, show_detail = true) {
            
            this.$store.dispatch('updateScheduledDate', 
                {id: rowData.id, 
                work_order_id: rowData.work_order_id,
                sale_id: rowData.sale_id, 
                customer_id: this.customer_id, 
                schedule_notes: rowData.schedule_notes, 
                appointment_date: rowData.appointment_date,
                show_detail,
                plannerSource: true})
            
            setTimeout(() => {
                let filterIndex = this.$store.state.production.planner.list.future_orders.findIndex(t => t.work_order_id == rowData.work_order_id)
                
                if(filterIndex>=0) {
                    this.$store.state.production.planner.list.future_orders[filterIndex].appointment_date = rowData.appointment_date
                    this.$store.state.production.planner.list.future_orders[filterIndex].appointment_date_changed = this.changeDate(rowData.appointment_date)
                }
    
            }, 500);

        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Planner/CustomerList/ProcessList/Index.vue